/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { EndDate } from '../models/EndDate';
import type { StartDate } from '../models/StartDate';
import type { VehicleId } from '../models/VehicleId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SensorsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Export temperature & humidity entries
     * Export bucketed sensor readings (temperature, humidity, thermo) for a vehicle as a file
     * @param vehicleId Vehicle ID
     * @param startDate Start date
     * @param type Export format
     * @param endDate End date
     * @param interval Bucket interval in minutes.
     * @param keys Sensor keys to include. Defaults to vehicle configuration if omitted.
     * @returns binary OK
     * @throws ApiError
     */
    public sensorsExport(
        vehicleId: VehicleId,
        startDate: StartDate,
        type: 'xlsx' | 'csv',
        endDate?: EndDate,
        interval: 1 | 15 = 15,
        keys?: Array<'ble_humidity' | 'ble_temperature' | 'humidity' | 'temperature' | 'thermo_temperature'>,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/sensors/export',
            query: {
                'vehicle_id': vehicleId,
                'start_date': startDate,
                'end_date': endDate,
                'interval': interval,
                'keys': keys,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                413: `Export data too large`,
                500: `Server error`,
                504: `Server error`,
            },
        });
    }
    /**
     * Get sensor readings
     * Get bucketed sensor readings (temperature, humidity, thermo) for a vehicle based on its sensor configuration
     * @param vehicleId Vehicle ID
     * @param startDate Start date
     * @param endDate End date
     * @param interval Bucket interval in minutes.
     * @param keys Sensor keys to include. Defaults to vehicle configuration if omitted.
     * @returns any OK
     * @throws ApiError
     */
    public sensors(
        vehicleId: VehicleId,
        startDate: StartDate,
        endDate?: EndDate,
        interval: 1 | 15 = 15,
        keys?: Array<'ble_humidity' | 'ble_temperature' | 'humidity' | 'temperature' | 'thermo_temperature'>,
    ): Observable<Record<string, Array<{
        date: string;
        values: Array<number | null>;
    }>>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/sensors/',
            query: {
                'vehicle_id': vehicleId,
                'start_date': startDate,
                'end_date': endDate,
                'interval': interval,
                'keys': keys,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
